import { Dialog } from "primereact/dialog";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../app/lang/langs";
import { Col, Row } from "react-bootstrap";
import '../../containers/settings/Modals/SettingsModal.css';
import { DynamicButton } from "../../components/buttons/DynamicButton";
import { getCollabsNames } from "../../components/vcomp/vcompSlice";
import { addCollabMission, editCollabMission, getCollabMissions } from "../../components/teams/teamsSlice";
import { getTeamCollabs } from "../../components/clients/clientsSlice";
import { showErrorToast } from "../../app/utils/helpers";
import { Calendar } from "primereact/calendar";
import moment from 'moment';
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from 'primereact/confirmdialog';
import { SelectInput } from "../../components/inputs/Select";
import { getPostes } from "../../components/collabs/collabsSlice";

export default function AddTeamsMembersModal(props) {

    const dispatch = useDispatch();

    const collabsNames = useSelector((state) => state.vcomp.collabsNames);
    const postes = useSelector((state) => state.collabs.postes);

    const [filteredCollabs, setFilteredCollabs] = useState([])
    const [associatedMembers, setAssociatedMembers] = useState(null)
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const collabMissions = useSelector((state) => state.teams.collabMissions);
    const [onGoingMission, setOnGoingMission] = useState(null);
    const [newPoste, setNewPoste] = useState()
    const [postesOptions, setPostesOptions] = useState([]);

    const [disabedDatesMissions, setDisabedDatesMissions] = useState([]);


    useEffect(() => {
        const options = postes?.map(poste => ({
            label: poste.name,
            value: poste.id
        }));
        setPostesOptions(options);
    }, [postes])

    useEffect(() => {
        if (associatedMembers && associatedMembers.id) {
            dispatch(getCollabMissions({ id_collab: associatedMembers.id }))
        }
    }, [associatedMembers])

    useEffect(() => {
        if (collabMissions && collabMissions.ongoingMissions) {
            setOnGoingMission(collabMissions.ongoingMissions[0] || null);
        }
    }, [collabMissions]);

    useEffect(() => {
        if (collabMissions) {
            const allMissions = [
                ...collabMissions.ongoingMissions,
                ...collabMissions.upcomingMissions,
                ...collabMissions.pastMissions
            ];

            const newDisabledDates = [];
            allMissions.forEach((mission) => {
                let start = mission.start_date ? new Date(mission.start_date) : null;
                let end = mission.end_date ? new Date(mission.end_date) : null;

                if (!start && !end) {
                    return;
                } else if (!start) {
                    return
                }

                else if (start && !end) {
                    end = moment().add(30, 'years').toDate();
                }

                let current = new Date(start);
                while (current <= end) {
                    newDisabledDates.push(new Date(current));
                    current.setDate(current.getDate() + 1);
                }
            });

            setDisabedDatesMissions(newDisabledDates);
        }
    }, [collabMissions]);

    useEffect(() => {
        dispatch(getCollabsNames())
        dispatch(getPostes())
        
        setFilteredCollabs(collabsNames.filter(collab => !props.prevCollabs.includes(collab.id)).map(({ id, nom, prenom }) => ({
            id,
            fullName: `${nom} ${prenom}`
        })))
    }, [props.idTeam, props.prevCollabs])


    const handleClose = () => {
        props.setVisible(false);
        setAssociatedMembers(null)
        setFilteredCollabs([])
        setStartDate(new Date());
        setEndDate(null);
        setNewPoste(null);
    }

    const handleAddMembers = () => {
        if (associatedMembers && associatedMembers.id && props.idTeam) {
            if (startDate && endDate && startDate > endDate) {
                showErrorToast('La date de début doit être antérieure ou égale à la date de fin.');
                return;
            }
            if (!newPoste) {
                showErrorToast('Veuillez choisir un poste.');
                return;
            }

            const allMissions = [
                ...collabMissions.ongoingMissions,
                ...collabMissions.upcomingMissions,
                ...collabMissions.pastMissions
            ];

            const allMissionDates = allMissions
                .filter(mission => mission.start_date)
                .map(mission => ({
                    start: moment(mission.start_date),
                    end: mission.end_date ? moment(mission.end_date) : null
                }));


            const newMissionStart = moment(startDate).format("YYYY-MM-DD HH:mm:ss");
            const newMissionEnd = endDate ? moment(endDate).format("YYYY-MM-DD HH:mm:ss") : null;

            // const isOverlap = allMissionDates.some(({ start, end }) => {
            //     if (!end) {
            //         return newMissionEnd
            //             ? newMissionEnd.isAfter(start)
            //             : newMissionStart.isBefore(start);
            //     }

            //     return newMissionStart.isBetween(start, end, null, "[)") ||
            //         (newMissionEnd && newMissionEnd.isBetween(start, end, null, "[)")) ||
            //         (newMissionStart.isSameOrBefore(start) && (newMissionEnd ? newMissionEnd.isSameOrAfter(end) : true));
            // });

            // if (isOverlap) {
            //     showErrorToast("La nouvelle mission chevauche une mission existante.");
            //     return;
            // }


            dispatch(addCollabMission({
                id_team: props.idTeam,
                id_collab: associatedMembers.id,
                start_date: moment(startDate).format("YYYY-MM-DD 00:00:00"),
                end_date: endDate ? moment(endDate).format("YYYY-MM-DD 23:59:59") : null,
                id_poste: newPoste
            }))
                .then((actionResponse) => {
                    if (addCollabMission.fulfilled.match(actionResponse)) {
                        if (actionResponse.payload.responseData && actionResponse.payload.responseData.status) {
                            dispatch(getTeamCollabs({ id_team: props.idTeam }));
                            handleClose();
                        } else {
                            if (actionResponse.payload.responseData.error && actionResponse.payload.responseData.error.includes("conflict")) {
                                showErrorToast("La mission est en conflit avec une autre")
                            }
                        }
                    }
                })
                .catch((error) => {
                    console.error(error)
                    console.error('Échec de l\'ajout/suppression des membres');
                })
        }
    }

    const confirmAddWithConflict = (idCollab, teamName, idTeam, startDate, endDate) => {
        const accept = () => {
            dispatch(editCollabMission(
                {
                    id_collab: idCollab,
                    end_date: startDate,
                    id_mission: onGoingMission.id_mission
                }
            )).then((actionResponse) => {
                if (editCollabMission.fulfilled.match(actionResponse)) {
                    if (actionResponse.payload.responseData && actionResponse.payload.responseData.status) {
                        dispatch(addCollabMission(
                            {
                                id_team: props.idTeam,
                                id_collab: idCollab,
                                start_date: startDate,
                                end_date: endDate,
                                id_poste: newPoste
                            }
                        )).then((actionResponse) => {
                            if (addCollabMission.fulfilled.match(actionResponse)) {
                                if (actionResponse.payload.responseData && actionResponse.payload.responseData.status) {
                                    dispatch(getTeamCollabs({ id_team: props.idTeam }));
                                    handleClose();
                                }
                            }
                        })
                    }
                }
            })
        };
        const reject = () => {
        };
        confirmDialog({
            message: `${teamName}`,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            acceptLabel: "Oui",
            rejectLabel: "Non",
            accept,
            reject
        });
    };

    const header = () => {
        return (
            <div>
                <Langs str='ADD_MEMBERS' />
            </div>
        )
    }

    const body = () => {
        return (
            <div className="p-2">
                <Row className="mt-2">
                    <Row className="mt-2 p-2 pb-3">
                        <Col lg={3} className="my-3 fw-bold">
                            <Langs str='Associated Members' />
                        </Col>
                        <Col lg={9} className="d-flex justify-content-end">
                            <Dropdown
                                value={associatedMembers}
                                onChange={(e) => { setAssociatedMembers(e.value) }}
                                options={filteredCollabs}
                                optionLabel="fullName"
                                display="chip"
                                filter
                                placeholder="Select to add..."
                                className='customMultiselect'
                                showClear
                            />
                        </Col>
                    </Row>
                    <Row className="mt-2 p-2 pb-3">
                        <Col lg={3} className="my-3 fw-bold">
                            <label className="fw-bold"><Langs str="POSTE" /></label>
                        </Col>
                        <Col lg={9} className="mb-1 pe-3">
                            <SelectInput
                                id="poste_name"
                                options={postesOptions}
                                value={newPoste}
                                onChange={(e) =>
                                    setNewPoste(e.value)
                                }
                                placeholder="Nom du poste"
                            />
                        </Col>
                    </Row>
                    <Row className="mt-2 p-2 pb-3">
                        <Col lg={3} className="my-3 fw-bold">
                            <Langs str="START_DATE" />
                        </Col>
                        <Col lg={9} className="d-flex justify-content-end">
                            <Calendar
                                value={startDate}
                                onChange={(e) => setStartDate(e.value)}
                                dateFormat="dd/mm/yy"
                                showIcon
                                disabledDates={disabedDatesMissions}
                            />
                        </Col>
                    </Row>
                    <Row className="mt-2 p-2 pb-3">
                        <Col lg={3} className="my-3 fw-bold">
                            <Langs str="END_DATE" />
                        </Col>
                        <Col lg={9} className="d-flex justify-content-end">
                            <Calendar
                                value={endDate}
                                onChange={(e) => setEndDate(e.value)}
                                dateFormat="dd/mm/yy"
                                showIcon
                                placeholder="(optional)"
                                showButtonBar
                                minDate={startDate}
                                disabledDates={disabedDatesMissions}
                            />
                        </Col>
                    </Row>
                </Row>
            </div>
        )
    }
    
    const footer = () => {
        return (
            <Row className="d-flex justify-content-center border-top pt-3">
                <Col lg={3} xs={3}>
                    <DynamicButton
                        onClick={() => { handleAddMembers() }}
                        className=''
                        title={<Langs str="ADD" />}
                        active={true}
                        color="green"
                    />
                </Col>
            </Row>
        )
    }

    return (
        <div>
            <Dialog
                header={header}
                footer={footer}
                visible={props.visible}
                style={{ width: '50vw' }}
                draggable={false}
                onHide={() => { if (!props.visible) return; handleClose() }}>
                {body()}
            </Dialog>
        </div>
    )
}